import { Injectable, inject } from '@angular/core';

import { Actions, createEffect } from '@ngrx/effects';

import { AuthService } from '@views/misc/auth/auth.service';

import * as actions from './bank-accounts.actions';
import { BankAccountsService } from './bank-accounts.service';

@Injectable()
export class Effects {
  private actions$ = inject(Actions);
  private bankAccountsService = inject(BankAccountsService);
  private authService = inject(AuthService);

  fetchList$ = createEffect(() =>
    this.authService.createGenericRequest({
      actions$: this.actions$,
      makeRequest: () => this.bankAccountsService.fetchList(),
      errorMessage: 'Sorry, there has been an error fetching your bank accounts',
      startAction: actions.bankAccountsFetchListStart,
      successAction: actions.bankAccountsFetchListSuccess,
      failAction: actions.bankAccountsFetchListFail,
    }),
  );
}
